module.exports = __webpack_public_path__ + "static/media/nespory.899e18b0.jpg";